export const environment = {
    production: true,
    CLIENTNAME: 'Algerie Booking',
    assets: 'algbooking',
    clientDisplayName: 'Algerie Booking',
    staticApi: 'https://static-api.algebratec.com/',
    serverURL: 'https://b2cbackend.algebratec.com',
    serverURL2: 'https://b2cbackend.algebratec.com',
    serverPool: [],
    phone: ['+213 23 11 61 80', '+213 23 11 61 81'],
    email: [],
    key: '2HeijriicyqGZxPuEEtb',    
    proAccessUrl: '',
    delivery: true,
    mode: 'B2C'
};
